import { render, staticRenderFns } from "./ThemeSettingsDirectBottom.vue?vue&type=template&id=14fdb6d8&scoped=true"
import script from "./ThemeSettingsDirectBottom.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fdb6d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14fdb6d8')) {
      api.createRecord('14fdb6d8', component.options)
    } else {
      api.reload('14fdb6d8', component.options)
    }
    module.hot.accept("./ThemeSettingsDirectBottom.vue?vue&type=template&id=14fdb6d8&scoped=true", function () {
      api.rerender('14fdb6d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/themes/ThemeSettingsDirectBottom.vue"
export default component.exports